import cal from "generate-calendar-url";

export default class CalendarDropdown {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.calendar-dropdown'), el => {
			new CalendarDropdown(el);
		});
	}

	classes = {
		main: 'calendar-dropdown',
		toggleButton: 'calendar-dropdown__toggle-button',
		links: 'calendar-dropdown__link',
		open: 'calendar-dropdown--is-open'
	}

	constructor(element) {
		if (!element) return;

		this.node = element;
		this.isOpen = false;
		this.toggleButton = this.node.querySelector('.' + this.classes.toggleButton);
		this.links = this.node.querySelector('.' + this.classes.links);

		window.addEventListener('mousedown', (e) => {
            // If the click is on the toggle button and its not open yet, then open it and exit the method
			if (this.isEventInside(e) && !this.isOpen) {
                this.open();
                return;
            }

            // If the click is on one of the download links in the dropdown, then execute the link
            if (e.target.classList.contains(this.classes.links)) {
                e.preventDefault();
                e.stopPropagation();

                // open the calendar
                this.openCalendarLink(e.target.dataset.type);
            }

            // Finally close the dropdown
            this.close();
		});
	}

	toDate(timestamp) {
		return new Date(parseInt(timestamp, 10) * 1000);
	}

	open() {
		if (this.isOpen) return;

		this.isOpen = true;
		this.node.classList.add(this.classes.open);
	}

	close() {
		if (!this.isOpen) return;

		this.isOpen = false;
		this.node.classList.remove(this.classes.open);
	}

	getEventData(dropdown) {
		const roundMinutes = (timestamp) => {
			let date = new Date(timestamp);
			date.setHours(date.getHours() + Math.round(date.getMinutes() / 60));
			date.setMinutes(0, 0, 0);
			return date.getTime();
		}

		let title = dropdown.dataset.title || '';
		let startDate = dropdown.dataset.start ? this.toDate(dropdown.dataset.start) : this.toDate(roundMinutes(Date.now())); // if no start date(timestamp), set it to next hour
		let endDate = dropdown.dataset.end ? this.toDate(dropdown.dataset.end) : startDate;
		let location = dropdown.dataset.location || '';
		let description = dropdown.dataset.description || '';

		return {
			title: title,
			start: startDate,
			end: endDate,
			location: location,
			description: description.replace('<br>', '<br><br>')
		};
	}

    openLinkWithFilename(uri, filename) {
        // see https://stackoverflow.com/questions/283956/is-there-any-way-to-specify-a-suggested-filename-when-using-data-uri
        const link = document.createElement('a');
        if (filename && typeof link.download === 'string') {
            link.href = uri;
            link.download = filename;

            //Firefox requires the link to be in the body
            document.body.appendChild(link);

            //simulate click
            link.click();

            //remove the link when done
            document.body.removeChild(link);
        } else {
            window.open(uri);
        }
    }

	openCalendarLink(type) {
		if (!type) type = 'google'; // google by default

		let event = this.getEventData(this.node);
        let title = this.node.dataset.title;

		switch (type) {
			case 'google':
                window.open(cal.google(event), '_blank');
				break;
			case 'outlook':
                this.openLinkWithFilename(cal.outlook(event), title ? title + '.ics' : null);
				break;
            case 'ics':
				this.openLinkWithFilename(cal.ical(event), title ? title + '.ics' : null);
				break;
		}
	}

	isEventInside(e) {
		let target = e.target;
		return !!target.closest('.' + this.classes.main);
	}
}
